import { Add, Delete } from "@mui/icons-material";
import {
  Alert,
  Autocomplete,
  Box,
  Fade,
  IconButton,
  Snackbar,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import { Loading } from "../../../common/components";

export const Integrantes = ({ equipo, setEquipo, acolitos }) => {
  const [loading, setLoading] = useState(true);
  const [acolitoIntegrante, setAcolitoIntegrante] = useState({
    id: 100,
    nombre_completo: "",
  });
  const [showAlert, setShowAlert] = useState(false);
  const [errorAlert, setErrorAlert] = useState(
    "Error: El acólito se encuentra asignado como capitán de este equipo."
  );

  // generarID a cada acolito que pertenece a este grupo
  const generarID = () => {
    let id = 1;
    let eq = equipo.acolitos.map((a) => {
      a.id_renglon = id;
      id++;
      return a;
    });
    setEquipo({ ...equipo, acolitos: eq });
    setLoading(false);
  };

  useEffect(() => {
    generarID();
  }, []);

  if (loading) {
    return <Loading />;
  }
  return (
    <Fade in={true} timeout={1000}>
      <Box sx={style.modal}>
        <Box
          sx={{
            padding: 5,
            borderRadius: 7,
            //Agregar sombra
            boxShadow: 5,
            width: "50%",
            margin: "auto",
            position: "relative",
          }}
        >
          <Typography
            id="transition-modal-description"
            variant="h6"
            color="secondary.dark"
            fontWeight={500}
            sx={{ marginBottom: 4 }}
          >
            Acólitos que pertenecen al equipo
          </Typography>
          {equipo.acolitos.map((acolito) => {
            //Si el acólito es el capitán, no mostrarlo en la lista
            if (acolito.id === equipo.id_capitan) return null;

            return (
              <Box
                key={acolito.id_renglon}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: 2,
                }}
              >
                <Tooltip title="Eliminar acólito" placement="left">
                  <IconButton
                    onClick={() => {
                      setEquipo({
                        ...equipo,
                        acolitos: equipo.acolitos.filter(
                          (a) => a.id_renglon !== acolito.id_renglon
                        ),
                      });
                    }}
                    sx={{ marginRight: 5 }}
                  >
                    <Delete color={"primary"} />
                  </IconButton>
                </Tooltip>
                <Autocomplete
                  options={acolitos}
                  value={acolitos.find((a) => a.id === acolito.id) || null}
                  getOptionLabel={(option) => option.nombre_completo}
                  isOptionEqualToValue={(option, value) =>
                    option.id === value.id
                  }
                  renderInput={(params) => (
                    <TextField {...params} label="Nombre del acólito" />
                  )}
                  sx={{ width: "80%" }}
                  onChange={(event, value) => {
                    value
                      ? value.id !== equipo.id_capitan //Si el acólito es el capitán
                        ? setEquipo({
                            ...equipo,
                            acolitos: equipo.acolitos.map((a) =>
                              a.id_renglon === acolito.id_renglon
                                ? {
                                    id: value.id,
                                    nombre_completo: value.nombre_completo,
                                    id_renglon: acolito.id_renglon,
                                  }
                                : a
                            ),
                          })
                        : setShowAlert(true)
                      : setEquipo({
                          ...equipo,
                          acolitos: equipo.acolitos.map((a) =>
                            a.id_renglon === acolito.id_renglon
                              ? {
                                  id: null,
                                  nombre_completo:
                                    acolitoIntegrante.nombre_completo,
                                  id_renglon: acolitoIntegrante.id,
                                }
                              : a
                          ),
                        });
                    setAcolitoIntegrante((prev) => ({
                      ...prev,
                      id: prev.id + 1,
                    }));
                  }}
                />
              </Box>
            );
          })}
          {/* // Botón para agregar un nuevo acólito */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginTop: 4,
              //   marginBottom: 2,
            }}
          >
            <Tooltip title="Agregar acólito" placement="left">
              <IconButton
                sx={{
                  backgroundColor: "secondary.light",
                }}
                onClick={() => {
                  setEquipo({
                    ...equipo,
                    acolitos: [
                      ...equipo.acolitos,
                      {
                        id: null,
                        nombre_completo: acolitoIntegrante.nombre_completo,
                        id_renglon: acolitoIntegrante.id,
                      },
                    ],
                  });
                  setAcolitoIntegrante((prev) => ({
                    ...prev,
                    id: prev.id + 1,
                  }));
                }}
              >
                <Add
                  color={"primary"}
                  sx={{
                    fontSize: 30,
                  }}
                />
              </IconButton>
            </Tooltip>
          </Box>
        </Box>
        <Snackbar
          open={showAlert}
          autoHideDuration={6000}
          onClose={() => setShowAlert(false)}
        >
          <Alert
            onClose={() => setShowAlert(false)}
            severity="error"
            variant="filled"
            sx={{ width: "100%" }}
          >
            {errorAlert}
          </Alert>
        </Snackbar>
      </Box>
    </Fade>
  );
};

const style = {
  modal: {
    // position: "absolute",
    top: "50%",
    left: "50%",
    // transform: "translate(-50%, -50%)",
    // width: "65%",
    bgcolor: "background.paper",
    // boxShadow: 24,
    p: 4,
    // borderRadius: 2,
  },
  modal_title: {
    textAlign: "center",
    marginBottom: 5,
  },
  inputs: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    marginBottom: 5,
    justifyContent: "space-around",
  },
};
